import React, { useState } from "react";
import AdminLiquidityStats from "./AdminLiquidityStats";
import AdminLiquidityIncidents from "./AdminLiquidityIncidents";
import AdminLiquidityFlaggedWallets from "./AdminLiquidityFlaggedWallets";

const TABS = [
  { id: "stats", label: "📊 Stato & Statistiche" },
  { id: "incidents", label: "⚠️ Incidenti" },
  { id: "flagged", label: "🚩 Wallet Segnalati" },
];

/**
 * Pannello admin completo per il monitoraggio della liquidità.
 * Contiene 3 sotto-tab: Stato/Statistiche, Incidenti, Wallet Segnalati.
 */
const AdminLiquidityPanel = ({ adminKey }) => {
  const [activeTab, setActiveTab] = useState("stats");

  return (
    <div style={s.wrapper}>
      <div style={s.header}>
        <h2 style={s.title}>💧 Liquidity Risk Monitoring</h2>
        <p style={s.subtitle}>
          Monitor liquidity program status, detected incidents and flagged wallets.
        </p>
      </div>

      {/* Tab bar */}
      <div style={s.tabBar}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              ...s.tabBtn,
              ...(activeTab === tab.id ? s.tabBtnActive : {}),
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Contenuto tab */}
      <div style={s.content}>
        {activeTab === "stats" && <AdminLiquidityStats adminKey={adminKey} />}
        {activeTab === "incidents" && <AdminLiquidityIncidents adminKey={adminKey} />}
        {activeTab === "flagged" && <AdminLiquidityFlaggedWallets adminKey={adminKey} />}
      </div>
    </div>
  );
};

const s = {
  wrapper: {
    maxWidth: 1100,
    margin: "0 auto",
  },
  header: {
    marginBottom: 20,
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    color: "#2c3e50",
    margin: "0 0 6px 0",
  },
  subtitle: {
    fontSize: 14,
    color: "#718096",
    margin: 0,
  },
  tabBar: {
    display: "flex",
    gap: 6,
    borderBottom: "2px solid #e2e8f0",
    marginBottom: 24,
    flexWrap: "wrap",
  },
  tabBtn: {
    padding: "10px 18px",
    backgroundColor: "transparent",
    border: "none",
    borderBottom: "3px solid transparent",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    color: "#718096",
    transition: "color 0.2s, border-color 0.2s",
    marginBottom: -2,
  },
  tabBtnActive: {
    color: "#2c3e50",
    borderBottomColor: "#27ae60",
    fontWeight: 700,
  },
  content: {
    minHeight: 300,
  },
};

export default AdminLiquidityPanel;
